import React, { useContext } from "react";
import { VariantContextData } from "../variants/VariantBuilderContext";
import VariantBuilderSetting from "../variants/VariantBuilderSetting";

const SectionLayoutSettings = (props) => {
  const [contextData, builder] = useContext(VariantContextData);
  const section = props.section;
  const row_element = props.row_element;
  const cta = contextData.objects.cta;
  const variant = contextData.objects.variant;

  return (
    <React.Fragment>
      <VariantBuilderSetting
        object={section}
        setting_name="[options][structure][mobile-responsive]"
        setting_type="checkbox"
        object_type="sections"
        object_id={section.id}
        label="Mobile Responsive"
        value={
          section.options["structure"]["mobile-responsive"]
            ? section.options["structure"]["mobile-responsive"]
            : "true"
        }
        tooltip="Toggling this off will prevent columns from responding to mobile device screen sizes and enable column size control for mobile"
      />

      <VariantBuilderSetting
        object={section}
        setting_name="[options][structure][hide-desktop]"
        setting_type="checkbox"
        object_type="sections"
        object_id={section.id}
        label="Hide on desktop"
        value={
          section.options["structure"]["hide-desktop"]
            ? section.options["structure"]["hide-desktop"]
            : "false"
        }
        tooltip="Want to display this only on mobile? Enable this option"
      />

      <VariantBuilderSetting
        object={section}
        setting_name="[options][structure][hide-mobile]"
        setting_type="checkbox"
        object_type="sections"
        object_id={section.id}
        label="Hide on mobile"
        value={
          section.options["structure"]["hide-mobile"]
            ? section.options["structure"]["hide-mobile"]
            : "false"
        }
        tooltip="Want to display this only on desktop? Enable this option"
      />

      <VariantBuilderSetting
        object={section}
        setting_name="[options][structure][sticky]"
        setting_type="checkbox"
        object_type="sections"
        object_id={section.id}
        label="Sticky (desktop)"
        value={
          section.options["structure"]["sticky"]
            ? section.options["structure"]["sticky"]
            : "false"
        }
        tooltip="Keep this section pinned to the top of the page while the visitor scrolls. Use for navigation headers."
        condition={!section.element_id}
        device="desktop"
      />

      <VariantBuilderSetting
        object={section}
        setting_name="[options][structure][sticky-mobile]"
        setting_type="checkbox"
        object_type="sections"
        object_id={section.id}
        label="Sticky (mobile)"
        value={
          section.options["structure"]["sticky-mobile"] ||
          section.options["structure"]["sticky"] ||
          "false"
        }
        tooltip="Keep this section pinned to the top of the page while the visitor scrolls. Use for navigation headers."
        condition={!section.element_id}
        device="mobile"
      />

      <VariantBuilderSetting
        object={section}
        setting_name="[options][structure][outer-container-width-style]"
        setting_type="dropdown"
        object_type="sections"
        object_id={section.id}
        label="Outer Container Width"
        value={
          section.options["structure"]["outer-container-width-style"]
            ? section.options["structure"]["outer-container-width-style"]
            : ""
        }
        options={[
          { value: "", text: "100%" },
          { value: "custom", text: "Custom" },
        ]}
        device="desktop"
        condition={row_element !== undefined}
      />

      <VariantBuilderSetting
        object={section}
        setting_name="[options][structure][outer-container-width-style-mobile]"
        setting_type="dropdown"
        object_type="sections"
        object_id={section.id}
        label="Outer Container Width"
        value={
          section.options["structure"]["outer-container-width-style-mobile"]
            ? section.options["structure"]["outer-container-width-style-mobile"]
            : ""
        }
        options={[
          { value: "", text: "100%" },
          { value: "custom", text: "Custom" },
        ]}
        device="mobile"
        condition={row_element !== undefined}
      />

      <VariantBuilderSetting
        object={section}
        setting_name="[options][structure][outer-container-width]"
        object_type="sections"
        object_id={section.id}
        setting_type="range"
        value={
          section.options["structure"]["outer-container-width"]
            ? section.options["structure"]["outer-container-width"]
            : undefined
        }
        label="Outer Container Width"
        min={1}
        max={2560}
        step={1}
        device="desktop"
        condition={
          row_element !== undefined &&
          section.options["structure"]["outer-container-width-style"] ==
            "custom"
        }
      />

      <VariantBuilderSetting
        object={section}
        setting_name="[options][structure][outer-container-width-mobile]"
        object_type="sections"
        object_id={section.id}
        setting_type="range"
        value={
          section.options["structure"]["outer-container-width-mobile"]
            ? section.options["structure"]["outer-container-width-mobile"]
            : undefined
        }
        label="Outer Container Width"
        min={1}
        max={2560}
        step={1}
        device="mobile"
        condition={
          row_element !== undefined &&
          section.options["structure"]["outer-container-width-style-mobile"] ==
            "custom"
        }
      />

      <VariantBuilderSetting
        object={section}
        setting_name="[options][structure][column-container]"
        setting_type="dropdown"
        object_type="sections"
        object_id={section.id}
        label="Inner Container Width"
        value={
          section.options["structure"]["column-container"]
            ? section.options["structure"]["column-container"]
            : ""
        }
        options={[
          { value: "full", text: "No Padding (Full Width)" },
          { value: "page", text: "Padded" },
          { value: "custom", text: "Custom" },
        ]}
        condition={
          section.step_id &&
          (cta.cta_type == "page" ||
            cta.cta_type == "bar" ||
            cta.cta_type == "inline" ||
            cta.cta_type == "overlay")
        }
      />

      <VariantBuilderSetting
        object={section}
        setting_name="[options][structure][inner-container-max-width]"
        object_type="sections"
        object_id={section.id}
        setting_type="range"
        value={
          section.options["structure"]["inner-container-max-width"]
            ? section.options["structure"]["inner-container-max-width"]
            : undefined
        }
        label="Inner Container Max Width"
        min={1}
        max={2560}
        step={1}
        device="desktop"
        condition={
          section.options["structure"]["column-container"] == "custom"
        }
      />

      <VariantBuilderSetting
        object={section}
        object_type="sections"
        object_id={section.id}
        setting_name="[options][structure][inner-container-max-width-mobile]"
        setting_type="range"
        value={
          section.options["structure"]["inner-container-max-width-mobile"]
            ? section.options["structure"]["inner-container-max-width-mobile"]
            : undefined
        }
        label="Inner Container Max Width"
        min={1}
        max={2560}
        step={1}
        device="mobile"
        condition={
          section.options["structure"]["column-container"] == "custom"
        }
      />

      <VariantBuilderSetting
        object={section}
        setting_name="[options][structure][browser-height]"
        setting_type="checkbox"
        object_type="sections"
        object_id={section.id}
        label="Expand to window height"
        value={
          section.options["structure"]["browser-height"]
            ? section.options["structure"]["browser-height"]
            : "false"
        }
        tooltip="Make this section's columns expand to the height of the browser window"
        condition={
          !section.element_id &&
          (cta.cta_type == "page" ||
            ((cta.cta_type == "inline" || cta.cta_type == "overlay") &&
              (variant["options"]["container-width"] == "100%" ||
                variant["options"]["container-width"] == "2560px")))
        }
        device="desktop"
      />

      <VariantBuilderSetting
        object={section}
        setting_name="[options][structure][browser-height-mobile]"
        setting_type="checkbox"
        object_type="sections"
        object_id={section.id}
        label="Expand to window height"
        value={
          section.options["structure"]["browser-height-mobile"]
            ? section.options["structure"]["browser-height-mobile"]
            : "false"
        }
        tooltip="Make this section's columns expand to the height of the browser window"
        condition={
          !section.element_id &&
          (cta.cta_type == "page" ||
            ((cta.cta_type == "inline" || cta.cta_type == "overlay") &&
              (variant["options"]["container-width"] == "100%" ||
                variant["options"]["container-width"] == "2560px")))
        }
        device="mobile"
      />

      <VariantBuilderSetting
        object={section}
        setting_name="[options][structure][column-min-height]"
        setting_type="range"
        object_type="sections"
        object_id={section.id}
        label="Minimum Column Height"
        units={["px"]}
        value={
          section.options["structure"]["column-min-height"]
            ? section.options["structure"]["column-min-height"]
            : undefined
        }
        min={0}
        max={2000}
        step={1}
        device="desktop"
        condition={section.options["structure"]["browser-height"] !== "true"}
        placeholder="auto"
        allow_empty={true}
        show_reset={true}
      />

      <VariantBuilderSetting
        object={section}
        setting_name="[options][structure][column-min-height-mobile]"
        setting_type="range"
        object_type="sections"
        object_id={section.id}
        label="Minimum Column Height"
        units={["px"]}
        value={
          section.options["structure"]["column-min-height-mobile"]
            ? section.options["structure"]["column-min-height-mobile"]
            : undefined
        }
        placeholder="auto"
        min={0}
        max={2000}
        step={1}
        device="mobile"
        condition={
          section.options["structure"]["browser-height-mobile"] !== "true"
        }
        allow_empty={true}
        show_reset={true}
      />

      <VariantBuilderSetting
        object={section}
        setting_name="[options][structure][container-SPACING_TYPE-"
        setting_type="spacing"
        object_type="sections"
        object_id={section.id}
        label={"Spacing"}
        condition={contextData.device == "desktop"}
        note="Click to increase and reduce spacing"
        padding_only={section.element_id == undefined}
      >
        {section.element_id && (
          <div className="row hard-center" style={{ marginTop: "10px" }}>
            <div className="col-xs-12">
              <div className="mb-[5px] text-xl text-black dark:text-white">
                Outer margin
              </div>
              <VariantBuilderSetting
                object={section}
                setting_name="[options][structure][container-margin-left]"
                setting_type="text"
                numeric_with_percentage={true}
                object_type="sections"
                object_id={section.id}
                value={section.options["structure"]["container-margin-left"]}
                placeholder="0px"
                col="3"
                note="Left"
                classNames="spacing-inputs"
                allow_empty={true}
              />

              <VariantBuilderSetting
                object={section}
                setting_name="[options][structure][container-margin-top]"
                setting_type="text"
                numeric_with_percentage={true}
                object_type="sections"
                object_id={section.id}
                value={section.options["structure"]["container-margin-top"]}
                placeholder="0px"
                col="3"
                note="Top"
                classNames="spacing-inputs"
                allow_empty={true}
              />

              <VariantBuilderSetting
                object={section}
                setting_name="[options][structure][container-margin-bottom]"
                setting_type="text"
                numeric_with_percentage={true}
                object_type="sections"
                object_id={section.id}
                value={section.options["structure"]["container-margin-bottom"]}
                placeholder="0px"
                col="3"
                note="Bottom"
                classNames="spacing-inputs"
                allow_empty={true}
              />

              <VariantBuilderSetting
                object={section}
                setting_name="[options][structure][container-margin-right]"
                setting_type="text"
                numeric_with_percentage={true}
                object_type="sections"
                object_id={section.id}
                value={section.options["structure"]["container-margin-right"]}
                placeholder="0px"
                col="3"
                note="Right"
                classNames="spacing-inputs"
                allow_empty={true}
              />
            </div>
          </div>
        )}

        <div className="row hard-center" style={{ marginTop: "15px" }}>
          <div className="col-xs-12">
            <div className="mb-[5px] text-xl text-black dark:text-white">
              Inner padding
            </div>
            <VariantBuilderSetting
              object={section}
              setting_name="[options][structure][container-padding-left]"
              setting_type="text"
              numeric_with_percentage={true}
              object_type="sections"
              object_id={section.id}
              value={builder.helpers.convertLegacyPadding(
                section.options["structure"]["container-padding-left"]
              )}
              placeholder="0px"
              col="3"
              note="Left"
              classNames="spacing-inputs"
              allow_empty={true}
            />

            <VariantBuilderSetting
              object={section}
              setting_name="[options][structure][container-padding-top]"
              setting_type="text"
              numeric_with_percentage={true}
              object_type="sections"
              object_id={section.id}
              value={builder.helpers.convertLegacyPadding(
                section.options["structure"]["container-padding-top"]
              )}
              placeholder="0px"
              col="3"
              note="Top"
              classNames="spacing-inputs"
              allow_empty={true}
            />

            <VariantBuilderSetting
              object={section}
              setting_name="[options][structure][container-padding-bottom]"
              setting_type="text"
              numeric_with_percentage={true}
              object_type="sections"
              object_id={section.id}
              value={builder.helpers.convertLegacyPadding(
                section.options["structure"]["container-padding-bottom"]
              )}
              placeholder="0px"
              col="3"
              note="Bottom"
              classNames="spacing-inputs"
              allow_empty={true}
            />

            <VariantBuilderSetting
              object={section}
              setting_name="[options][structure][container-padding-right]"
              setting_type="text"
              numeric_with_percentage={true}
              object_type="sections"
              object_id={section.id}
              value={builder.helpers.convertLegacyPadding(
                section.options["structure"]["container-padding-right"]
              )}
              placeholder="0px"
              col="3"
              note="Right"
              classNames="spacing-inputs"
              allow_empty={true}
            />
          </div>
        </div>
      </VariantBuilderSetting>

      <VariantBuilderSetting
        object={section}
        setting_name="[options][structure][container-SPACING_TYPE-mobile-"
        setting_type="spacing"
        object_type="sections"
        object_id={section.id}
        label={
          section.element_id
            ? "Outer Margin & Inner Padding"
            : "Section Padding"
        }
        condition={contextData.device == "mobile"}
        device="mobile"
        note="Click to increase and reduce spacing"
        padding_only={section.element_id == undefined}
      >
        {section.element_id && (
          <div className="row hard-center" style={{ marginTop: "10px" }}>
            <div className="col-xs-12">
              <div className="mb-[5px] text-xl text-black dark:text-white">
                Outer margin{" "}
                <span
                  className="glyphicon glyphicon-phone tooltip-icon"
                  data-toggle="tooltip"
                  data-placement="top"
                  title="Mobile only"
                  aria-hidden="true"
                  style={{
                    color: "#00b593",
                    fontSize: "14px",
                  }}
                ></span>
              </div>
              <VariantBuilderSetting
                object={section}
                setting_name="[options][structure][container-margin-mobile-left]"
                setting_type="text"
                numeric_with_percentage={true}
                object_type="sections"
                object_id={section.id}
                value={
                  section.options["structure"]["container-margin-mobile-left"]
                }
                placeholder="0px"
                col="3"
                note="Left"
                classNames="spacing-inputs"
                allow_empty={true}
              />

              <VariantBuilderSetting
                object={section}
                setting_name="[options][structure][container-margin-mobile-top]"
                setting_type="text"
                numeric_with_percentage={true}
                object_type="sections"
                object_id={section.id}
                value={
                  section.options["structure"]["container-margin-mobile-top"]
                }
                placeholder="0px"
                col="3"
                note="Top"
                classNames="spacing-inputs"
                allow_empty={true}
              />

              <VariantBuilderSetting
                object={section}
                setting_name="[options][structure][container-margin-mobile-bottom]"
                setting_type="text"
                numeric_with_percentage={true}
                object_type="sections"
                object_id={section.id}
                value={
                  section.options["structure"]["container-margin-mobile-bottom"]
                }
                placeholder="0px"
                col="3"
                note="Bottom"
                classNames="spacing-inputs"
                allow_empty={true}
              />

              <VariantBuilderSetting
                object={section}
                setting_name="[options][structure][container-margin-mobile-right]"
                setting_type="text"
                numeric_with_percentage={true}
                object_type="sections"
                object_id={section.id}
                value={
                  section.options["structure"]["container-margin-mobile-right"]
                }
                placeholder="0px"
                col="3"
                note="Right"
                classNames="spacing-inputs"
                allow_empty={true}
              />
            </div>
          </div>
        )}

        <div className="row hard-center" style={{ marginTop: "15px" }}>
          <div className="col-xs-12">
            <div className="mb-[5px] text-xl text-black dark:text-white">
              Inner padding{" "}
              <span
                className="glyphicon glyphicon-phone tooltip-icon"
                data-toggle="tooltip"
                data-placement="top"
                title="Mobile only"
                aria-hidden="true"
                style={{
                  color: "#00b593",
                  fontSize: "14px",
                }}
              ></span>
            </div>
            <VariantBuilderSetting
              object={section}
              setting_name="[options][structure][container-padding-mobile-left]"
              setting_type="text"
              object_type="sections"
              object_id={section.id}
              value={
                builder.helpers.convertLegacyPadding(
                  section.options["structure"]["container-padding-mobile-left"]
                ) ||
                builder.helpers.convertLegacyPadding(
                  section.options["structure"]["container-padding-left"]
                )
              }
              numeric_with_percentage={true}
              placeholder="0px"
              col="3"
              note="Left"
              classNames="spacing-inputs"
              allow_empty={true}
            />

            <VariantBuilderSetting
              object={section}
              setting_name="[options][structure][container-padding-mobile-top]"
              setting_type="text"
              object_type="sections"
              object_id={section.id}
              value={
                builder.helpers.convertLegacyPadding(
                  section.options["structure"]["container-padding-mobile-top"]
                ) ||
                builder.helpers.convertLegacyPadding(
                  section.options["structure"]["container-padding-top"]
                )
              }
              numeric_with_percentage={true}
              placeholder="0px"
              col="3"
              note="Top"
              classNames="spacing-inputs"
              allow_empty={true}
            />

            <VariantBuilderSetting
              object={section}
              setting_name="[options][structure][container-padding-mobile-bottom]"
              setting_type="text"
              object_type="sections"
              object_id={section.id}
              value={
                builder.helpers.convertLegacyPadding(
                  section.options["structure"][
                    "container-padding-mobile-bottom"
                  ]
                ) ||
                builder.helpers.convertLegacyPadding(
                  section.options["structure"]["container-padding-bottom"]
                )
              }
              numeric_with_percentage={true}
              placeholder="0px"
              col="3"
              note="Bottom"
              classNames="spacing-inputs"
              allow_empty={true}
            />

            <VariantBuilderSetting
              object={section}
              setting_name="[options][structure][container-padding-mobile-right]"
              setting_type="text"
              object_type="sections"
              object_id={section.id}
              value={
                builder.helpers.convertLegacyPadding(
                  section.options["structure"]["container-padding-mobile-right"]
                ) ||
                builder.helpers.convertLegacyPadding(
                  section.options["structure"]["container-padding-right"]
                )
              }
              numeric_with_percentage={true}
              placeholder="0px"
              col="3"
              note="Right"
              classNames="spacing-inputs"
              allow_empty={true}
            />
          </div>
        </div>
      </VariantBuilderSetting>
    </React.Fragment>
  );
};

export default SectionLayoutSettings;
